import { render, staticRenderFns } from "./AttachmentsAppointment.vue?vue&type=template&id=ba283fb4"
import script from "./AttachmentsAppointment.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachmentsAppointment.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports